import { Disclosure } from './Disclosure'
import { SessionTimesFields } from './SessionTimesFields'
import type { SessionTimes } from '../model/workSessionTime'

/** Manual time editing is hidden from workers (managers only, and no manager flow uses this yet). */
const SHOW_MANUAL_TIME_EDITING = false

interface Props {
  times: SessionTimes
  editable: Array<keyof SessionTimes>
  onChange: (times: SessionTimes) => void
  open: boolean
  onToggle: () => void
}

/**
 * "Zeiten anpassen", collapsed by default. Collapsed IS the design: the default submit files
 * what the taps measured, and opening this is the technician saying a tap was late.
 */
export function SessionTimesDisclosure({ times, editable, onChange, open, onToggle }: Props) {
  if (!SHOW_MANUAL_TIME_EDITING) return null

  return (
    <Disclosure label="Zeiten anpassen" open={open} onToggle={onToggle}>
      <p className="mb-3 text-xs text-gray-500">
        Nur nötig, wenn ein Tipp zu spät kam. Die Dauern werden aus den Zeitpunkten berechnet.
      </p>
      <SessionTimesFields times={times} editable={editable} onChange={onChange} />
    </Disclosure>
  )
}
